import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import gazetteer, { CountryCodes, defaultLocale, Market } from '@bridebook/toolbox/src/gazetteer';
import { countriesExcludedFromSignup } from '@bridebook/toolbox/src/i18n/features';
import { ICountryOption } from '@bridebook/ui';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import FlagCountrySelector from '@bridebook/web/components/bbcommon/flag-country-selector/flag-country-selector';
import { getIsCordova } from '@bridebook/web/lib/mobile-app/selectors';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import { useSelector } from '@bridebook/web/lib/utils';
import { changeLanguage } from '@bridebook/web/lib/change-language/utils/change-language';

const AuthCountrySelect = () => {
  const { t } = useTranslation('signup');
  const router = useRouter();
  const market = useMarket();

  const isCordova = useSelector(getIsCordova);

  const countriesFilter = useCallback(
    (market: Market) =>
      isCordova ||
      (market.hasAnyDirectory && !countriesExcludedFromSignup.includes(market.country)),
    [isCordova],
  );

  const changeFormCountryValue = useCallback(
    async (option: ICountryOption) => {
      const newMarket = gazetteer.getMarketByCountry(option.value as CountryCodes);
      await changeLanguage(newMarket.flags.translated ? newMarket.locale : defaultLocale);

      router.push(`/${newMarket.prefix}${UrlHelper.signup}`, undefined, { locale: false });
    },
    [router],
  );

  return (
    <FlagCountrySelector
      onClick={changeFormCountryValue}
      modalHeader={t('selectOrSearchForCountry')}
      selectedCountry={market.country}
      countriesFilter={countriesFilter}
    />
  );
};

export default AuthCountrySelect;
